<template>
  <div>
    <span class="mr-3">{{ title }}</span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon color="primary" dark v-bind="attrs" v-on="on">
          mdi-information
        </v-icon>
      </template>
      <span>{{ description }} </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'HeaderTitle',

  props: {
    homeViewMode: {
      type: String,
      default: 'CARD',
    },
  },

  computed: {
    title() {
      return {
        CARD: 'Histórico de Pautas',
        TABLE: 'Tempo Real',
        CONTACT: 'Contatos',
        MIRROR: 'Espelhos',
        MIRROR_HISTORIC: 'Histórico de Espelhos',
      }[this.homeViewMode];
    },

    description() {
      return {
        CARD:
          'Navegue pelo acervo de retrancas do iNEWS. Pesquise pelo conteúdo, título, data e autor.',
        TABLE: 'Navegue pelas gavetas do iNEWS através do Newshub.',
        CONTACT:
          'Navegue pelo acervo de retrancas para buscar contatos. Pesquise por nome, telefone, e-mail ou endereço.',
        MIRROR:
          'Acompanhe os espelhos dos jornais em tempo real. O Newshub é integrado com o iNEWS.',
        MIRROR_HISTORIC:
          'Navegue pelo acervo de espelhos do iNEWS. Pesquise pelo conteúdo, título, data e autor.',
      }[this.homeViewMode];
    },
  },
};
</script>
